import styled from "styled-components";
import { ToastContainer as Container } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastContainer = styled(Container)`
  .Toastify__progress-bar-theme--dark{
      background:linear-gradient(90deg,#FB8404 0%,#FE1E14 100%),#C4C4C4 !important;
      
  }
`